import { useContext, useEffect, useState } from 'react';
import invariant from 'ts-invariant';
import { getWaysteContext } from '../context/WaysteContext';
export function useIsAppAdmin(override) {
    const context = useContext(getWaysteContext());
    const [adminToken, setAdminToken] = useState(null);
    const isAdmin = !!adminToken;
    const client = override || context.client;
    invariant(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <WaysteProvider>, or pass an WaysteClient ' +
        'instance in via options.');
    useEffect(() => {
        const betaTesterSub = client.auth().appAdmin.subscribe((adminAuthority) => {
            setAdminToken(adminAuthority || null);
        });
        return () => {
            betaTesterSub.unsubscribe();
        };
    }, [client]);
    return {
        isAdmin,
        adminToken,
    };
}
//# sourceMappingURL=useIsAppAdmin.js.map